import {common_utils} from "../common/common_utils";

function game_3000()
{

}


game_3000.getWinInfo = function(this1,obj)
{
    if(common_utils.isNull(obj))
    {
      return winInfo;
    }
    let winInfo = "";
    let winInfoTip= "";

    let winValue = 0;
    let index = 0;
    Object.keys(obj).map(function(key) {
      let subitem = obj[key];
      let bet = 0;
      //let win = 0;
      let odd = 0;
      if(subitem.Bet)
      {
        bet = subitem.Bet;
      }
      // if(subitem.Win)
      // {
      //   win = subitem.Win;
      // }
      if(subitem.JumpPoint)
      {
        odd = subitem.JumpPoint
      }
      if(index > 0)
      {
        winInfo += " + ";
        winInfoTip+= " + ";
      }
      winInfo += " ("+(bet  / 100).toFixed(2)+" x "+ odd +" - "+((bet) / 100).toFixed(2)+")"
      winInfoTip += " ("+this1.$t("lang.str_game_bet")+(index+1)+" x "+ this1.$t("lang.str_3200_CashOutX")+(index+1)+" - "+this1.$t("lang.str_game_bet")+(index+1)+")"
      index++;
    });
    winInfo += " = ";
    winInfoTip+= " = ";
   index = 0;
   Object.keys(obj).map(function(key) {
       let subitem = obj[key];
       let bet = 0;
       let win = 0;
       let odd = 0;
       if(subitem.Bet)
       {
         bet = subitem.Bet;
       }
       if(subitem.Win)
       {
         win = subitem.Win;
       }
       if(index > 0)
       {
         winInfo += " + ";
         winInfoTip+= " + ";
       }
       winInfo += " ("+(win  / 100).toFixed(2)+" - "+((bet) / 100).toFixed(2)+")"
       winInfoTip += " ("+this1.$t("lang.str_parachute_money")+(index+1)+" - "+this1.$t("lang.str_game_bet")+(index+1)+")"
       winValue += win-bet;
       index++;
  });
  winInfoTip += " = "+ this1.$t("lang.tr_game_total_win")
  winInfo += " = " +((winValue) / 100).toFixed(2);
  return [winInfo,winInfoTip];
}

export {
  game_3000
};



// WEBPACK FOOTER //
// ./src/components/esports/game_3000.js